<template>
	<div class="form-container">
		<div v-if="message" class="message">{{ message }}</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'UnregisteredPageLayout',
	props: {
		message: {
			type: String,
			default: ''
		}
	},
}
</script>

<style>
.form-container {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	overflow: hidden;
}

.form-container form {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: calc(100% - 40px);
	max-width: 350px;
	box-sizing: border-box;
}

.form-container input {
	width: 100%;
	padding: 10px;
	border: 1px solid #ddd;
	border-radius: 4px;
	margin: 2px;
	font-size: 16px;
	font-family: monospace;
	line-height: 1.5;
	box-sizing: border-box;
	background-color: rgba(255, 255, 255, 0.85);
}

.form-container .message {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #ff4444;
	font-size: 14px;
	background-color: rgba(255, 255, 255, 0.85);
	padding: 10px;
	border-radius: 4px;
}

.form-container button {
	display: none;
}

</style>

